export default __webpack_public_path__ + "static/media/icon-files.c1f1d299.svg";